import { useEffect, useState } from "react";
import { Box, Text, Button ,TextInput, Menu,createStyles, Tooltip} from "@mantine/core";
import React from "react";
import "./style.css";
import PreviousCustomers from "./PreviousCustomers";
import { IoMdAdd } from "react-icons/io";
import { IoPersonAddOutline } from "react-icons/io5";
import { CiSearch } from "react-icons/ci";
import { LuArrowDownUp } from "react-icons/lu";
import { getAllBillingConsumers } from "../../../services/billinginvoice";
import { useSelector } from "react-redux";


const useStyles = createStyles(() => ({

  tabsinner: {
     width: "15%",
    borderRadius: "8px",
  background:"#1018280D",
  border:'1px solid var(--app-border)',
    padding: "8px 14px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textAlign: "center",
    cursor: "pointer",
    // height:'6vh'
  },}));

const Customers = ({ setState }) => {
  const [createconsumer, setCreateConsumer] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const { classes } = useStyles();

 const { stripeaccounts  } = useSelector(
    (state) => state.settinginvoice
  );
     const {settingInvoice} = useSelector(
        (state) => state.settinginvoice
      );
  


  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query); // Update the search query state

    // Clear the previous timeout to reset the debouncing process
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    // Set a new timeout to call the API after 500ms delay
    const timeout = setTimeout(() => {
      getAllBillingConsumers({ query, page: 1 }); // Trigger the API call
    }, 500); // 500ms delay

    setDebounceTimeout(timeout); // Store the timeout ID to clear it later
  };

  useEffect(() => {
    // Cleanup the timeout when the component unmounts
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [debounceTimeout]);

const handlefindcustomer=async(value)=>{
  let payload={
    status:value,
  }

  await getAllBillingConsumers(payload)


}


  return (
    <div className="maindashbordinvoices">
      {/* <Text style={{marginTop:'20px'}} fs={16} fw={700} color="var(--app-text)">
      All Customers
      </Text> */}
      <Box className="allInvoicesSection">
        <Text fs={16} fw={700} color="var(--app-text)">
          All Customers
        </Text>
        <div style={{ display: "flex", gap: "1rem" }}>
          <Button
            onClick={() => {
              setCreateConsumer(true);
            }}
            variant="filled"
            type="submit"
            c={"var(--app-text)"}
            radius={"md"}
            size="md"
            style={{background:"#1018280D",border:'1px solid var(--app-border)'}}
          >
            <IoPersonAddOutline/>
            <div style={{marginLeft:'.5rem'}} >Add Customer</div>
          </Button>

          {
            (
              !stripeaccounts?.StripeAccounts || (
                stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' &&
                (
                  settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
                  settingInvoice?.settinginvoice?.paymentsOptions?.ach
                )
              )
            ) ? (
              <Tooltip
                label="Your stripe account is not registered, go to settings tab and update it."
                withArrow
                position="bottom"
              >
                <img
                  width={20}
                  height={20}
                  style={{ position: "relative", top: "13px" }}
                  src="/assets/images/error.png"
                  alt="check-icon"
                />
              </Tooltip>
            ) : null
          }
          <Button
            onClick={() => {
              setState(true);
            }}
            disabled={
              !stripeaccounts?.StripeAccounts || (
                stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' &&
                (
                  settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
                  settingInvoice?.settinginvoice?.paymentsOptions?.ach
                )
              )
            }
            variant="filled"
            type="submit"
            c={"var(--app-on-primary)"}
            radius={"md"}
            size="md"
            sx={{ backgroundColor: "var(--app-primary)", color: "var(--app-on-primary)", "&:hover": { backgroundColor: "var(--app-primary)", filter: "brightness(0.95)" } }}
            style={{display:"flex",gap:'.5rem'}}
          >
            <IoMdAdd size={25} />
            <div  style={{marginLeft:'.5rem'}} >New Invoice</div>
          </Button>
        </div>
      </Box>
      <Box className="dashbordinvoices">
        <div style={{display:'flex',gap:'1rem'}} >
          <TextInput
            rightSection={<CiSearch size={20} color="var(--app-text-muted)" />}
            className="search-section"
            // left={<CiSearch />}
            placeholder="Search Customer name"
            value={searchQuery}
            onChange={handleSearch}
          />
          {/* <Button
            variant="filled"
            type="submit"
            c={"var(--app-text)"}
            radius={"md"}
            size="md"
            style={{background:"#1018280D",border:'1px solid var(--app-border)'}}
          >
            <LuArrowDownUp />
            <div style={{marginLeft:'.5rem'}} >Sort By</div>
          </Button> */}

<Box
              // style={{ backgroundColor: settingtrue }}
              className={classes.tabsinner}
            >
              <Menu  shadow="md" width={100}>
                <Menu.Target>
                  <Box
                    style={{
                      display: "flex",
                      // gap: "20px",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                 <div>

      <LuArrowDownUp width={20} />
    </div>
                   <Text ff={14} fw={700} c={
                    'var(--app-text)'}  style={{marginLeft:'.5rem'}}>Sort By</Text>
                  </Box>
                </Menu.Target>

                <Menu.Dropdown pos={"bottom-start"} top={'261px'}  >
                  <Menu.Item

                  ff="Inter" fz={14} fw={600} color="var(--app-text)"
                  //  onClick={HandleNavigatepair}
                   onClick={()=>{handlefindcustomer('all')}}

                  // onClick={() => handleEditProvider({ id: 1 }, true)}
                  >
                   All
            
                  </Menu.Item>
                  <Menu.Item
                            ff="Inter" fz={14} fw={600} color="var(--app-text)"
                             onClick={()=>{handlefindcustomer('active')}}

                  // onClick={() => handleEditProvider({ id: 1 }, false)}
                  >
                 Active
                
                  </Menu.Item>
                  <Menu.Item
                  ff="Inter" fz={14} fw={600} color="var(--app-text)"
                   onClick={()=>{handlefindcustomer('non-active')}}
                  >
                    InActive
                
                  </Menu.Item>
     

                  
                </Menu.Dropdown>
              </Menu>
            </Box>

        </div>
        <PreviousCustomers
          createconsumer={createconsumer}
          setCreateConsumer={setCreateConsumer}
        />
      </Box>
    </div>
  );
};

export default Customers;
